
import { defineComponent, PropType } from 'vue';
import FbxButton from '@/components/fbx-button.vue';
import VirtualRedTagHeader from '@/components/VirtualRedTag/VirtualRedTagHeader.vue';
import VirtualRedTagTrailerGraphic from '@/components/VirtualRedTag/VirtualRedTagTrailerGraphic.vue';
import trailerByNumber from '@/shared/mixins/trailerByNumber';
import { VirtualRedTagTrailerGraphicState } from '@/types/VirtualRedTagTrailerGraphicState';
import { VirtualRedTagEvaluationType } from '@/types/VirtualRedTagEligibility';

const DEFAULT_SUBTITLE = "This trailer isn't available for Red Tag right now.";

const SUBTITLES: Record<VirtualRedTagEvaluationType, string> = {
    [VirtualRedTagEvaluationType.trailerCompany]:
        'This trailer belongs to a different company.',
    [VirtualRedTagEvaluationType.trailerType]:
        'Only Dry Van and Refrigerated trailers can be Red Tagged.',
    [VirtualRedTagEvaluationType.trailerAttached]:
        'It is likely attached to another driver in the system.',
    [VirtualRedTagEvaluationType.trailerStatus]:
        "This trailer's current status doesn't allow it to be Red Tagged.",
    // Advisory evaluations never fail, so they never land on this screen.
    [VirtualRedTagEvaluationType.trailerReserved]: DEFAULT_SUBTITLE,
    [VirtualRedTagEvaluationType.trailerProximity]: DEFAULT_SUBTITLE,
    [VirtualRedTagEvaluationType.evaluationException]: DEFAULT_SUBTITLE,
};

export default defineComponent({
    name: 'VirtualRedTagUnavailable',
    components: {
        FbxButton,
        VirtualRedTagHeader,
        VirtualRedTagTrailerGraphic,
    },
    mixins: [trailerByNumber],
    props: {
        reason: {
            type: String as PropType<VirtualRedTagEvaluationType | undefined>,
            default: undefined,
        },
    },
    async created(): Promise<void> {
        await this.fetchTrailerByNumber();
    },
    computed: {
        GraphicState(): typeof VirtualRedTagTrailerGraphicState {
            return VirtualRedTagTrailerGraphicState;
        },
        subtitle(): string {
            // reason arrives from the query string, so it can be anything at all.
            return (this.reason && SUBTITLES[this.reason]) || DEFAULT_SUBTITLE;
        },
    },
    methods: {
        navigateToWelcome(): void {
            this.$router.push({ name: 'VirtualRedTagEntry' });
        },
    },
});
